var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile is-padded-left is-padded-right"},[_c('div',{staticClass:"column is-half-desktop is-full-mobile is-padded-left quotes"},[_c('b',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }